import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { PickerItem } from '../../models/picker-item.model';

export class AddContactData {
    public selectedUser: PickerItem;
    public isPrimaryConact: boolean;

    public constructor(selectedUser: PickerItem, isPrimaryConact: boolean = false) {
        this.selectedUser = selectedUser;
        this.isPrimaryConact = isPrimaryConact;
    }
}

@Component({
    selector: 'app-add-contact',
    templateUrl: './add-contact.dialog.html',
    styleUrl: './add-contact.dialog.scss',
    standalone: false
})
export class AddContactDialog {
    private selectedUser: PickerItem;

    public isPrimaryContact: boolean = false;

    public constructor(
        @Inject(MAT_DIALOG_DATA) data,
        public dialogRef: MatDialogRef<AddContactDialog>) {

    }

    public onUserSet(user: PickerItem) {
        console.log(user);
        this.selectedUser = user;
    }

    public closeDialog(save: boolean) {
        if (save) {
            this.dialogRef.close(new AddContactData(this.selectedUser, this.isPrimaryContact));
        } else {
            this.dialogRef.close();
        }
    }

    // getters
    public get ContactName(): string {
        return this.selectedUser?.displayName;
    }
    public get Phone(): string {
        return this.selectedUser?.phone
    }
    public get Email(): string {
        return this.selectedUser?.secondaryDisplayName;
    }
    public get Agency(): string {
        return this.selectedUser?.agencyShortName;
    }
    public get SelectedUser(): PickerItem {
        return this.selectedUser;
    }

}
